const cards = [
  {
    id: 1,
    title: '日剧必看榜',
    desc: '豆瓣高分日剧一网打尽，从经典到最新热播',
    tag: '日剧',
    img: 'https://readdy.ai/api/search-image?query=A%20collection%20of%20Japanese%20television%20drama%20scenes%20with%20cherry%20blossoms%20and%20city%20streets%2C%20warm%20natural%20lighting%2C%20nostalgic%20and%20romantic%20atmosphere%2C%20cinematic%20color%20grading%20with%20soft%20pastel%20tones%2C%20Japanese%20drama%20aesthetic&width=600&height=400&seq=card-01&orientation=landscape',
  },
  {
    id: 2,
    title: '美剧热播榜',
    desc: '最受欢迎美剧排行，悬疑、科幻、剧情一应俱全',
    tag: '美剧',
    img: 'https://readdy.ai/api/search-image?query=American%20TV%20series%20dramatic%20scene%20with%20city%20skyline%20at%20night%2C%20modern%20urban%20setting%2C%20intense%20character%20moment%2C%20cinematic%20lighting%20with%20cool%20blue%20and%20warm%20amber%20contrast%2C%20premium%20television%20production%20quality&width=600&height=400&seq=card-02&orientation=landscape',
  },
  {
    id: 3,
    title: '国产剧精选',
    desc: '年度口碑国产剧合集，古装、都市、悬疑全覆盖',
    tag: '国产剧',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20scene%20with%20traditional%20palace%20architecture%20and%20flowing%20silk%20costumes%2C%20warm%20golden%20hour%20lighting%2C%20epic%20and%20elegant%20composition%2C%20rich%20cultural%20aesthetic%20with%20red%20and%20gold%20accents&width=600&height=400&seq=card-03&orientation=landscape',
  },
  {
    id: 4,
    title: '华语电影馆',
    desc: '华语经典与新片汇聚，从文艺到商业大片',
    tag: '华语电影',
    img: 'https://readdy.ai/api/search-image?query=A%20Chinese%20cinema%20scene%20with%20dramatic%20mountain%20landscape%20and%20traditional%20elements%2C%20artistic%20composition%2C%20cinematic%20widescreen%20format%2C%20warm%20earthy%20tones%20with%20misty%20atmosphere%2C%20film%20festival%20quality%20aesthetic&width=600&height=400&seq=card-04&orientation=landscape',
  },
  {
    id: 5,
    title: '欧美大片厅',
    desc: '好莱坞最新最热大片集合，动作视效拉满',
    tag: '欧美大片',
    img: 'https://readdy.ai/api/search-image?query=Hollywood%20blockbuster%20action%20scene%20with%20explosive%20visual%20effects%20and%20dramatic%20lighting%2C%20cinematic%20composition%20with%20heroic%20silhouette%2C%20intense%20orange%20and%20teal%20color%20grading%2C%20epic%20movie%20poster%20aesthetic&width=600&height=400&seq=card-05&orientation=landscape',
  },
  {
    id: 6,
    title: '动漫番剧区',
    desc: '热门动漫番剧一站追更，日漫国漫随心切换',
    tag: '动漫',
    img: 'https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20with%20vibrant%20colors%20and%20dynamic%20composition%2C%20Japanese%20animation%20aesthetic%20with%20cherry%20blossoms%20and%20modern%20cityscape%2C%20artistic%20and%20expressive%20character%20design%2C%20warm%20and%20inviting%20color%20palette&width=600&height=400&seq=card-06&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1200px] mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              精选推荐
            </h2>
            <p className="mt-2 text-sm text-foreground-600">
              按类型发现你喜欢的影视内容
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {cards.map((card) => (
              <a
                key={card.id}
                href="#"
                onClick={(e) => e.preventDefault()}
                className="group block bg-background-50 rounded-lg border border-background-200/60 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer"
              >
                <div className="relative w-full aspect-[3/2] overflow-hidden bg-background-100">
                  <img
                    src={card.img}
                    alt={card.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <div className="absolute top-3 left-3 px-2.5 py-1 bg-black/60 text-background-50 text-xs font-medium rounded whitespace-nowrap">
                    {card.tag}
                  </div>
                </div>
                <div className="p-5">
                  <h3 className="text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors duration-200">
                    {card.title}
                  </h3>
                  <p className="mt-1 text-sm text-foreground-600">
                    {card.desc}
                  </p>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}